import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Button, TextField } from '@riac/design-system';


dayjs.extend(customParseFormat);

type BirthdayVerifierProps = {
  validationYears?: number,
  showButtons?: boolean,
  onValidDate?: () => void,
  onInvalidDate?: () => void,
}

export const BirthdayVerifier = ({
  validationYears = 18,
  showButtons = true,
  onValidDate = () => {
    return;
  },
  onInvalidDate = () => {
    return;
  },
}: BirthdayVerifierProps): JSX.Element => {
  const [month, setMonth] = useState<number>(null);
  const [day, setDay] = useState<number>(null);
  const [year, setYear] = useState<number>(null);
  const [validDate, setValidDate] = useState<boolean>(false);

  const handleVerifyAge = ():boolean => {
    const dateString = `${year}-${month}-${day}`;
    if(!dateString.match(/\d{4}-\d{1,2}-\d{1,2}/)) {
      return false;
    }
    const dateToCheck = dayjs(dateString, 'YYYY-M-D', true);
    if(dateToCheck && dateToCheck.isValid() && dayjs().diff(dateToCheck, 'year') >= validationYears) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    setValidDate(handleVerifyAge());
    if(!showButtons && handleVerifyAge()) {
      onValidDate();
    }
  }, [month, day, year]);

  return (
    <div>
      <div className={'text-neutral-700'}>Enter your date of birth</div>
      <div className={'flex flex-row gap-3 flex-wrap sm:flex-nowrap'}>
        <div className={'flex flex-row gap-3'}>
          <div className={'grow sm:w-20'}>
            <TextField
              autoFocus={true}
              inputMode={'numeric'}
              onChange={(value) => setMonth(parseInt(value))}
              placeholder={'MM'}/>
          </div>
          <div className={'grow sm:w-20'}>
            <TextField
              inputMode={'numeric'}
              onChange={(value) => setDay(parseInt(value))}
              placeholder={'DD'}/>
          </div>
        </div>
        <div className={'grow'}>
          <TextField
            inputMode={'numeric'}
            onChange={(value) => setYear(parseInt(value))}
            placeholder={'YYYY'}/>
        </div>
      </div>
      {showButtons && (
        <div className='flex flex-row gap-3 justify-evenly mt-3'>
          <Button
            isDisabled={!validDate}
            onPress={() => {
              if(handleVerifyAge()) {
                onValidDate();
              }
            }}>
            Verify Age
          </Button>
          <Button
            variant='secondary'
            destructive
            onPress={() => {
              onInvalidDate();
            }}>
            I am under {validationYears}
          </Button>
        </div>
      )}
    </div>
  );
};
